import { useACLContext } from 'src/providers/ACLProvider/ACL.hook';
import type { tBillingPermissions } from 'src/providers/ACLProvider/ACL.types';

/**
 * RET-2027: the billing gates the current member passes.
 *
 * Reads ACL's role flags, the app's one reading of `currentUserRole`
 * (UserProvider, resolved by WorkspaceProvider), so there is no second copy of
 * the role. Until WorkspaceProvider answers, that role reads SELLER and every
 * gate stays closed. A surface that fetches on mount waits for the role
 * (`isRoleResolved`) instead of deciding on that placeholder.
 */
export function useBillingPermissions(): tBillingPermissions {
  const { userIsOwner, userIsAdmin } = useACLContext();
  return { canPurchaseCredits: userIsOwner || userIsAdmin };
}
